import React, { useState } from 'react';
import { useRef, useEffect, forwardRef, useImperativeHandle } from 'react'
import { ReactSVG } from "react-svg";
import i18n from "../../i18n/i18n.js";
import TypedLink from '../../components/TypedLink/TypedLink';
import { Utils } from '../../Utils.js';
import FavoriteIcon from '../FavoreiteIcon/FavoriteIcon.js';

import './ProductListItem.css';
import { th } from 'framer-motion/client';

const ProductListItem = forwardRef((props, ref) => {

  const [product, setProduct] = useState((props.product) ? props.product : {});
  const [show_fav_icon,setFavIcon] = useState((props.show_fav_icon) ? props.show_fav_icon : false);
  const [index,setIndex] = useState((props.index) ? props.index : 0);
  const productImageRef = useRef(null);

  const renderStyle = props.renderStyle ? props.renderStyle : 'default';
  const show_product_rating = props.show_product_rating ? props.show_product_rating : false;
  const thumbSize = props.thumbSize ? props.thumbSize : 'thumb_medium_';

  const handle_product_click = (e, product) => {
    if(typeof props.parentFunction==='function'){
        props.parentFunction(e, product);
    }
  };
  
  useImperativeHandle(ref, () => ({
    // Expose parent function to parent component
    callParentFunction: handle_product_click,
  }));

  function renderImage(product)
  {
    if(product?.product_image?.[0]?.[thumbSize]?.filename)
    {
      return <span className='product_image_cont'><img ref={productImageRef} src={process.env.REACT_APP_ORIGINAL_SHOP_URL+'/'+product.product_image[0][thumbSize].filename}/></span>;
    }
    else
    {
      return <span className='product_image_cont'><img ref={productImageRef} src='/assets/images/no_image.png' /></span>;
    }
  }

  function renderSmallproductBox() {
    return <div className="small-product-box">
      {renderSaleBadge()}
      {renderNewnessBadge()}
      <TypedLink onClick={(e) => handle_product_click(e, product)} link={{type: 'product', url: product.url}}>
        {renderImage(product)}
        {renderProductPrice()}
      </TypedLink>
    </div>;
  }

  function renderDefaultProductBox(){
    return <div className="default-product-box">
      {renderSaleBadge()}
      {renderNewnessBadge()}
      {renderProductLabels()}
      {render_fav_icon()}
      <TypedLink onClick={(e) => handle_product_click(e, product)} link={{type: 'product', url: product.url}}>
        {renderImage(product)}
      </TypedLink>
      
      <TypedLink onClick={(e) => handle_product_click(e, product)} link={{type: 'product', url: product.url}}>
        <div className="name">{product.product}</div>
      </TypedLink>
      {render_rating()}
      <div className="price-and-cart-button">
        {
          product.show_only_professional 
          ? <div className="only-professional-label">{i18n.t('onlyForProfessionalUsers')}</div> 
          : <>
            {renderProductPrice()}
            {renderAddProductToCartButton()}
          </>
        }
        
      </div>
    </div>;
  }

  function render_fav_icon(){
    return (show_fav_icon ? <FavoriteIcon product={product} /> : '');
  }

  function render_rating(){

    if((!show_product_rating || product.product_rating_average<=0)){
      return null;
    }

    const stars = [];
    const fullStars = Math.floor(product.product_rating_average);
    const halfStar = (product.product_rating_average - fullStars) >= 0.5;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

    for (let i = 0; i < fullStars; i++) stars.push('fullStars');
    if (halfStar) stars.push('halfStar');
    for (let i = 0; i < emptyStars; i++) stars.push('emptyStars');

    return (
      <div className="product-rating">
        <span className="rating-value">{stars.map((star,index) => {
          <span key={index}><ReactSVG  className={`star-${star}`} src={`assets/images/star.svg`} /></span>;
        })}</span>
      </div>
    );
  }

  function renderSaleBadge(){
    return (parseInt(product.sale)>0 ? <div className='sale badge'>-{Math.floor(product.sale_percentage)}%</div> : '');
  }

  function renderNewnessBadge(){
    return (parseInt(product.newness)>0 ? <div className='newness badge'>{i18n.t('productItemNewBadge')}</div> : '');
  }

  function renderProductLabels() {
    
    const labelData = Utils.getProductLabelElement(product, 'product_list_item');
    
    if (!labelData) {
      return null;
    }

    return (
      <div className={`badge product-label`}>
        <img 
          src={process.env.REACT_APP_ORIGINAL_SHOP_URL + '/upload_files/products_parameters/' + labelData.image} 
          alt={labelData.productParameter} 
        />
      </div>
    );
  }

  function renderAddProductToCartButton(){
  
    let showCartButton = true;

    if(product?.no_stock_only_order ){
      showCartButton = false;
    }

    if(product.grouped_products && product.grouped_products.length>1){
      showCartButton = false;
    }

    if(!showCartButton){
      return null;
    }

    return (<div className="add-to-cart-button" onClick={() => Utils.add_product_to_shopping_cart(product.id,1,null,productImageRef.current)}>
      <ReactSVG src={`/assets/images/cart_black_bg.svg`} />
    </div>);
  }

  function renderProductPrice(){
    return (
      <div className="price">
        {parseInt(product.sale) > 0 ? <span className="sale">{product.price_gross}</span> : ''}
        <span className={`${parseInt(product.sale)>0 ? 'stroked' : ''}`}>{(parseInt(product.sale) > 0) ?  product.price_original_gross : product.price_gross}</span>
      </div>
    );
  } 

  return ( 
    <div key={product.id} data-index={product.index} className={`product_list_item ${(product.sale) ? ' sale' : ''}  ${parseInt(product.newness)>0 ? ' newness' : ''}`}> 

      {renderStyle==='smallProductBox' ? renderSmallproductBox() : renderDefaultProductBox()}

    </div>
  );

  /* 

      <div className="product_image">
        <TypedLink onClick={(e) => handle_product_click(e, product)} link={{type: 'product', url: product.url}}>
          {show_fav_icon ? <ReactSVG className="fav" onClick={(e) => handle_fav_click(e)} src={`assets/images/fav_${product.fav ? 'on' : 'off'}_black.svg`} /> : ''}
          {render_image(product)}
        </TypedLink>
      </div> 

      <div className="name"><b>{product.product}</b></div>

      <div className="price">
        <b className={`${!!product.sale ? 'stroked' : ''}`}>{(product.sale!==0) ?  product.price_original_gross : product.price_gross}</b>
        {!!product.sale ? <b className="sale">{product.price_gross}</b> : ''}
      </div>
      */
});
/*
class ProductListItem extends React.Component {

  max_quantity = 100;

  constructor(props) {
    super(props);

    this.state = {
      product: props.product ? props.product : {},
      show_fav_icon: props.show_fav_icon ? props.show_fav_icon : false,
    };

    this.parent_obj = props.parent_obj ? props.parent_obj : null;
    this.on_fav_click = props.on_fav_click ? props.on_fav_click : () => {};
    this.on_product_click = props.on_product_click ? props.on_product_click : () => {};

  }

  handle_product_click(event) {

    if(this.parent_obj && this.parent_obj.set_list_back_cache!==undefined)
    {
      this.parent_obj.set_list_back_cache();
    }

    this.on_product_click(event, this.state.product);
  }

  handle_fav_click(event) {

    event.preventDefault();

    const product = this.state.product;

    product.fav = product.fav ? 0 : 1;

    this.setState({product}, () => {
      this.on_fav_click(this.state.product);
    });
  }

  render_image(product)
  {
    if((product.product_image && product.product_image[0].thumb_list_new_ && product.product_image[0].thumb_list_new_.filename) )
    {
      return <img src={process.env.REACT_APP_ORIGINAL_SHOP_URL+'/'+product.product_image[0].thumb_list_new_.filename}/>
    }
  }

  render() {

    const { product, show_fav_icon } = this.state;

    if (!!product.id)
    {
      return ( 

        <div key={product.id} className={`product_list_item ${(product.sale) ? ' sale' : ''}  ${(product.newness) ? ' newness' : ''}`}> 

          {product.sale ? <div className='sale badge'>{i18n.t('productItmeSaleBadge')}</div> : ''}
          {product.newness ? <div className='newness badge'>{i18n.t('productItemNewBadge')}</div> : ''}

          <div className="product_image">
            <TypedLink onClick={(e) => this.handle_product_click(e)} link={{type: 'product', url: product.url}}>
              {show_fav_icon ? <ReactSVG className="fav" onClick={(e) => this.handle_fav_click(e)} src={`assets/images/fav_${product.fav ? 'on' : 'off'}_black.svg`} /> : ''}
              {this.render_image(product)}
            </TypedLink>
          </div> 

          <div className="name"><b>{product.product}</b></div>

          <div className="price">
            <b className={`${!!product.sale ? 'stroked' : ''}`}>{(product.sale!==0) ?  product.price_original_gross : product.price_gross}</b>
            {!!product.sale ? <b className="sale">{product.price_gross}</b> : ''}
          </div>

        </div>
      );
    }
    else {
      return '';
    }
  }
};
*/

export default ProductListItem;